<template>
  <b-container class="auth-page">
    <div class="auth-card">
      <router-link :to="{ name: 'base' }" class="auth-card__brand">
        <brand-logo />
      </router-link>
      <h1 class="auth-card__title">{{ title }}</h1>
      <p v-if="subtitle" class="auth-card__subtitle">{{ subtitle }}</p>
      <slot />
    </div>
  </b-container>
</template>

<script>
  import BrandLogo from '@anonymous/components/BrandLogo.vue'

  export default {
    name: 'AuthCard',

    components: {
      BrandLogo,
    },

    props: {
      title: {
        type: String,
        required: true,
      },
      subtitle: {
        type: String,
        required: false,
      },
    },
  }
</script>

<style scoped>
  .auth-page {
    padding-top: 2rem;
    padding-bottom: 3rem;
  }

  .auth-card {
    max-width: 26rem;
    margin: 0 auto;
    background: #fff;
    border: 1px solid var(--ui-border);
    border-radius: 12px;
    padding: 2rem 1.5rem;
    box-shadow: var(--ui-shadow);
  }

  .auth-card__brand {
    display: flex;
    justify-content: center;
    margin-bottom: 1.25rem;
  }

  .auth-card__title {
    font-size: 1.5rem;
    font-weight: 700;
    text-align: center;
    color: var(--ui-ink);
    margin-bottom: 1.5rem;
  }

  .auth-card__subtitle {
    text-align: center;
    color: var(--ui-muted);
    margin-top: -1rem;
    margin-bottom: 1.5rem;
  }

  @media (min-width: 768px) {
    .auth-page {
      padding-top: 3.5rem;
    }

    .auth-card {
      padding: 2.5rem 2rem;
    }
  }
</style>
